import "@/index.css";
import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import CoverPage from "@/components/CoverPage";
import ProjectList from "@/components/ProjectList";
import Workspace from "@/components/Workspace";
import Login from "@/components/Login";
import Signup from "@/components/Signup";
import { PaymentSuccess, PaymentCancel } from "@/components/PaymentPages";
import AdminSubscribers from "@/components/AdminSubscribers";
import SuperAdminOrgs from "@/components/SuperAdminOrgs";
import VsMicrosoftProject from "@/components/VsMicrosoftProject";
import GuidePage, { GuidesHub } from "@/components/seo/GuidePage";
import ComparePage, { CompareHub } from "@/components/seo/ComparePage";
import { ToolsHub, CutoverTimelineBuilder } from "@/components/seo/Tools";
import ReadinessCalculator from "@/components/seo/ReadinessCalculator";
import AdminGrowth from "@/components/seo/AdminGrowth";
import Contact from "@/components/Contact";
import Terms from "@/components/legal/Terms";
import Privacy from "@/components/legal/Privacy";
import PricingPage from "@/components/PricingPage";
import AboutPage from "@/components/AboutPage";
import EnterprisePage from "@/components/EnterprisePage";
import { ResourcesHub, ResourceDetail } from "@/components/Resources";
import EmbedPage from "@/components/EmbedPage";
import LinkedInKit from "@/components/LinkedInKit";
import { ExitIntentModal } from "@/components/marketing/ConversionKit";
import { captureUtm } from "@/lib/posterAttribution";
import HarmonizerProtected from "@/components/HarmonizerProtected";
import { CSuiteAuthProvider } from "@/state/CSuiteAuthContext";
import { CSuiteLogin, CSuiteSignup, CSuiteVerify } from "@/components/csuite/CSuiteAuthScreens";
import CSuiteDashboard from "@/components/csuite/CSuiteDashboard";
import CSuiteDemoStart from "@/components/csuite/CSuiteDemoStart";
import CSuiteProjectView from "@/components/csuite/CSuiteProjectView";
import AdminTestTechs from "@/components/admin/AdminTestTechs";
import TestTechApp from "@/components/testtech/TestTechApp";
import { TestingAdminLogin } from "@/components/testtech/UnifiedView";
import { CSuiteProtected } from "@/components/csuite/CSuiteProtected";

function App() {
  React.useEffect(() => { captureUtm(); }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <CSuiteAuthProvider>
          <ExitIntentModal />
          <Routes>
            <Route path="/" element={<CoverPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/enterprise" element={<EnterprisePage />} />
            <Route path="/resources" element={<ResourcesHub />} />
            <Route path="/resources/:slug" element={<ResourceDetail />} />
            <Route path="/embed" element={<EmbedPage />} />
            <Route path="/linkedin" element={<LinkedInKit />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/admin/subscribers" element={<AdminSubscribers />} />
            <Route path="/admin/orgs"        element={<SuperAdminOrgs />} />
            <Route path="/admin/test-techs"  element={<AdminTestTechs />} />
            <Route path="/test-tech/*"       element={<TestTechApp />} />
            <Route path="/testing-admin"     element={<TestingAdminLogin />} />
            <Route path="/vs/microsoft-project" element={<VsMicrosoftProject />} />
            <Route path="/guides" element={<GuidesHub />} />
            <Route path="/guides/:slug" element={<GuidePage />} />
            <Route path="/compare" element={<CompareHub />} />
            <Route path="/compare/:slug" element={<ComparePage />} />
            <Route path="/tools" element={<ToolsHub />} />
            <Route path="/tools/go-live-readiness-calculator" element={<ReadinessCalculator />} />
            <Route path="/tools/cutover-timeline-builder" element={<CutoverTimelineBuilder />} />
            <Route path="/admin/growth" element={<AdminGrowth />} />
            <Route path="/projects" element={<HarmonizerProtected><ProjectList /></HarmonizerProtected>} />
            <Route path="/projects/:id" element={<HarmonizerProtected><Workspace /></HarmonizerProtected>} />
            <Route path="/share/:id" element={<Workspace readOnly />} />

            {/* C-Suite portal */}
            <Route path="/csuite" element={<CSuiteLogin />} />
            <Route path="/csuite/demo" element={<CSuiteDemoStart />} />
            <Route path="/csuite/signup" element={<CSuiteSignup />} />
            <Route path="/csuite/verify" element={<CSuiteVerify />} />
            <Route path="/csuite/dashboard" element={<CSuiteProtected><CSuiteDashboard /></CSuiteProtected>} />
            <Route path="/csuite/project/:id" element={<CSuiteProtected><CSuiteProjectView /></CSuiteProtected>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </CSuiteAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
